export const DataKeluhan = {
  howTo: {
    steps: [
      "Bukti transaksi dan/atau bukti lain yang terkait dengan keluhan.",
      `Jika pelanggan memberi kuasa kepada orang lain untuk bertindak atas nama pelanggan, maka pelanggan harus menyertakan Surat kuasa bermeterai, KTP Pemberi Kuasa (Konsumen) dan KTP yang Diberi Kuasa. Surat kuasa keluhan dapat di unduh <a class="text--red text--bold" target="_blank" href="/static/pdf/Surat-Kuasa-Keluhan.pdf">disini</a>.`
    ]
  }
};
